import { z } from 'zod';
export const SendMessageRequestSchema = z.object({
    content: z.string().min(1, 'Message cannot be empty').max(20_000),
});
export const ConversationIdParamSchema = z.object({ id: z.string().uuid() });
export const MessageIdParamSchema = z.object({ id: z.string().uuid() });
export const CreateConversationRequestSchema = z.object({
    agentId: z.string().uuid(),
    initialMessage: z.string().min(1).max(20_000).optional(),
});
export const ListMessagesQuerySchema = z.object({
    /** Returns items strictly OLDER than this message id (cursor pagination). */
    before: z.string().uuid().optional(),
    /** Max items per page; hard-capped at 100 (M3.10). */
    limit: z.coerce.number().int().min(1).max(100).default(100),
});
export const ListConversationsQuerySchema = z.object({
    /** Returns items strictly older than this conversation id (cursor pagination). */
    cursor: z.string().uuid().optional(),
    /** Max items per page; hard-capped at 100. */
    limit: z.coerce.number().int().min(1).max(100).default(100),
});
/**
 * Admin variant of the conversation-list query. Bypasses the per-user scope
 * and adds optional filters: by owning user, by agent, and free-text search
 * over title + user email. All filters are optional; omitting them returns
 * every conversation in the platform (newest-first, paginated).
 */
export const AdminListConversationsQuerySchema = z.object({
    cursor: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    userId: z.string().uuid().optional(),
    agentId: z.string().uuid().optional(),
    q: z.string().trim().min(1).max(120).optional(),
});
//# sourceMappingURL=message.schema.js.map